module.exports = new __parcel__URL__("dark.40f58242.svg").toString();